import { ResponseParams, requestHttpPost } from './RequestBase';

type CheckWhiteListReqData = {
	burl?: string;
	bsn?: string;
	scd: string;
};
export const callCheckWhiteListApi = async (body: CheckWhiteListReqData): Promise<ResponseParams<void>> => {
	const result: ResponseParams<void> = await requestHttpPost(`/whitelist/check`, body);
	return result;
};
